import { render, staticRenderFns } from "./SettingPassword.vue?vue&type=template&id=a4df9b7c&scoped=true&"
import script from "./SettingPassword.vue?vue&type=script&lang=js&"
export * from "./SettingPassword.vue?vue&type=script&lang=js&"
import style0 from "./SettingPassword.vue?vue&type=style&index=0&id=a4df9b7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4df9b7c",
  null
  
)

export default component.exports